<template>
  <div>
    <vxe-grid
      ref="storeTable"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="381"
      size="mini"
      resizable
      row-id="amzStoreCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      cell-class-name="align-top"
      :checkbox-config="{ highlight: true, reserve: true, trigger: 'row' }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      :class="disabled ? 'disabled-table' : ''"
    >
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayStoreNo="{ row }">
        <span>NO：</span><span>{{ row.amzStoreNo }}</span>
        <br />
        <span>NAME：</span
        ><span style="color: #303133">{{ row.amzStoreName }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" style="width: 50%;" />
          <p class="no-data mt-1">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableDataMap() {
      if (!this.tableData || !this.tableData.length) return {}
      return Object.fromEntries(this.tableData.map((o) => [o.amzStoreCode, o]))
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    setCheckboxRows(rowids) {
      if (!rowids || !rowids.length) return
      const rows = rowids.map((id) => this.tableDataMap[id])
      this.$refs.storeTable.setCheckboxRow(rows, true)
      this.$emit('checkbox-change', rows)
    },
    clearCheckboxRow() {
      this.$refs.storeTable.clearCheckboxRow()
      this.$refs.storeTable.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .disabled-table .vxe-body--column {
    pointer-events: none;
  }
  .disabled-table .vxe-header--column {
    pointer-events: none;
  }
}
</style>
